import React, { useCallback } from 'react';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { useCloudIdToUrl } from '@atlaskit/linking-common/hooks';
import { Anchor, Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { AIModeIcon } from './assets/AIModeIcon';

type AISearchButtonProps = {
	aiModePromptLabel: string;
	aiModeQuery: string;
	cloudId: string;
	onClick: () => void;
};

const styles = cssMap({
	aiModePromptLabelStyles: {
		font: token('font.body'),
		fontWeight: token('font.weight.regular', '400'),
		paddingLeft: token('space.025'),
		paddingRight: token('space.0'),
	},
});

export const AIModeButton = ({
	aiModePromptLabel,
	aiModeQuery,
	cloudId,
	onClick: onButtonClick,
}: AISearchButtonProps): React.JSX.Element => {
	const { data } = useCloudIdToUrl(cloudId || '');
	const onClickCallback = useCallback(() => {
		onButtonClick();
	}, [onButtonClick]);

	return (
		<Anchor href={`${data}/wiki/ai-search/?aiSearchQuery=${aiModeQuery}`} onClick={onClickCallback}>
			<Button iconBefore={AIModeIcon}>
				<Box xcss={styles.aiModePromptLabelStyles}>{aiModePromptLabel}</Box>
			</Button>
		</Anchor>
	);
};
